var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomerTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85398 0.967407C7.20744 0.967407 7.49398 1.25394 7.49398 1.60741V6.55014C7.49398 6.78213 7.43093 7.00976 7.31157 7.2087L2.22434 15.6874H15.3236L10.2364 7.20869C10.117 7.00976 10.054 6.78213 10.054 6.55014V1.60741C10.054 1.25394 10.3405 0.967407 10.694 0.967407C11.0474 0.967407 11.334 1.25394 11.334 1.60741V6.55014L16.4212 15.0288C16.5377 15.2231 16.6007 15.4448 16.6035 15.6713C16.6064 15.8978 16.5491 16.1209 16.4375 16.3181C16.3259 16.5152 16.164 16.6791 15.9683 16.7932C15.7726 16.9073 15.5501 16.9674 15.3236 16.9674H2.22434C1.99782 16.9674 1.77537 16.9073 1.57968 16.7932C1.38399 16.6791 1.22208 16.5152 1.11048 16.3181C0.998877 16.1209 0.94158 15.8978 0.944438 15.6713C0.947296 15.4448 1.01021 15.2231 1.12675 15.0288L6.21398 6.55014V1.60741C6.21398 1.25394 6.50051 0.967407 6.85398 0.967407Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93408 1.60741C4.93408 1.25394 5.22062 0.967407 5.57408 0.967407H11.9741C12.3275 0.967407 12.6141 1.25394 12.6141 1.60741C12.6141 1.96087 12.3275 2.24741 11.9741 2.24741H5.57408C5.22062 2.24741 4.93408 1.96087 4.93408 1.60741Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4878 13.0599C5.98418 11.8081 4.62655 12.2471 3.92033 12.7618C3.63469 12.97 3.23436 12.9072 3.02616 12.6216C2.81797 12.3359 2.88076 11.9356 3.1664 11.7274C4.35199 10.8633 6.24187 10.5058 9.06024 11.915C10.416 12.5929 11.4312 12.7695 12.1748 12.7195C12.9099 12.67 13.425 12.3964 13.7866 12.0876C14.0554 11.8581 14.4593 11.8899 14.6889 12.1587C14.9184 12.4275 14.8866 12.8314 14.6178 13.061C14.0688 13.5298 13.2979 13.9268 12.2607 13.9966C11.232 14.0658 9.98835 13.8101 8.4878 13.0599Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerTest);
export default __webpack_public_path__ + "static/media/CustomerTest.47680834d58f2cafec216e5623cd2dcb.svg";
export { ForwardRef as ReactComponent };